import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { IonTabs, ViewWillEnter, ViewWillLeave } from '@ionic/angular';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { UsabillaSdkService } from '@shared/services/usabilla-sdk.service';
import { Observable, Subscription } from 'rxjs';
import { NotificationsService } from '@notifications/services/notifications.service';
import { Capacitor } from '@capacitor/core';
import { Router } from '@angular/router';
import { OrderService } from '@order/services/order.service';
import { UserService } from '@app/user/services';
import { ListUpdatesService } from '@app/lists/services/list-updates.service';
import { PlatformEnum } from '@shared/constants/platform-type.enum';
import { AuthConnectService } from '@panamax/app-state';
import { GuestPageService } from '@shared/services/guest-page/guest-page.service';

@Component({
  selector: 'app-tabs',
  templateUrl: './touch.page.html',
  styleUrls: ['./touch.page.scss'],
})
export class TouchPage implements OnInit, ViewWillEnter, ViewWillLeave {
  @ViewChild('tabs', { static: false }) tabs: IonTabs;
  @ViewChild('tabBar', { static: false }) tabBar: ElementRef;
  @Input() networkStatus: boolean;

  isGuestUser$: Observable<boolean>;
  isGuestUser: boolean;
  listUpdatesExist$: Observable<boolean>;
  PlatformEnum = PlatformEnum;

  showFab = true;
  selectedTab = '';
  unreadNotifications: number;
  unreadNotificationsSub$: Subscription = new Subscription();

  constructor(
    readonly panAppState: PanAppState,
    private notificationsService: NotificationsService,
    private usabillaSdkService: UsabillaSdkService,
    readonly orderService: OrderService,
    readonly platformService: PlatformService,
    public router: Router,
    private userService: UserService,
    private listUpdateService: ListUpdatesService,
    public el: ElementRef,
    private authConnectService: AuthConnectService,
    private guestPageService: GuestPageService,
  ) {}

  ngOnInit() {
    this.isGuestUser$ = this.userService.isGuestUser$();
    this.listUpdatesExist$ = this.listUpdateService.listUpdatesExist$();
    this.isGuestUser$.subscribe(value => {
      this.isGuestUser = value;
    });
  }

  ionViewWillEnter() {
    if (!Capacitor.isNativePlatform()) {
      this.showFab = false;
    }
    this.getUnreadNotificationsCount();
    this.usabillaSdkService.setUsabillaSDKVariables();
    this.hideDefaultTabClass();
  }

  setSelectedTab(): string {
    this.selectedTab = this.tabs.getSelected();
    return this.selectedTab;
  }

  feedbackButton() {
    this.usabillaSdkService.loadSDKForm();
  }

  getUnreadNotificationsCount() {
    this.unreadNotificationsSub$ = this.notificationsService
      .getUnreadTotalCount$()
      ?.subscribe(count => {
        this.unreadNotifications = count;
      });
  }

  ionViewWillLeave() {
    if (this.unreadNotificationsSub$) {
      this.unreadNotificationsSub$.unsubscribe();
    }
  }

  hideDefaultTabClass() {
    if (this.tabBar?.nativeElement) {
      this.tabBar.nativeElement.classList.remove('tab-bar-hidden');
    }
  }

  async logout(): Promise<void> {
    await this.authConnectService.logout();
  }

  async onBecomeACustomerClick() {
    this.guestPageService.trackBecomeACustomerButtonClickAndRedirect();
  }
}
